import './style.scss';

import React from 'react';

const FullLogo = ({ ...props }) => {
  return (
    <>
      <svg
        width="209"
        height={props.height || '100'}
        className="kliks-logo-svg"
        viewBox="0 0 209 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.7195 60.0425L48.4847 33.2268L24 45.589L28.335 48.936L16.8419 64.2102C14.3228 67.5581 14.2374 72.1449 16.6302 75.5841L33.2291 99.4422H48.9604L28.8115 71.3399C28.1885 70.4709 28.208 69.2964 28.8596 68.4486L38.0761 56.4573L42.7195 60.0425Z"
          fill="#16B396"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.6156 0C98.9691 0 102.498 3.52917 102.498 7.88261C102.498 11.4634 97.1654 20.4422 95.2725 23.2957C95.1265 23.5159 94.8799 23.6483 94.6156 23.6483C94.3514 23.6483 94.1048 23.5159 93.9588 23.2957C92.0659 20.4422 86.733 11.4634 86.733 7.88261C86.733 3.52917 90.2622 0 94.6156 0Z"
          fill="#16B396"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.8485 99.4422V20.5627H72.2368V99.4422H58.8485ZM87.8304 99.4422V37.4194H101.219V99.4422H87.8304ZM205.319 56.488V44.6617C201.525 43.0253 196.765 42.2072 191.038 42.2072C185.087 42.2072 180.141 43.6947 176.199 46.6699C172.257 49.6451 170.286 53.736 170.286 58.9425C170.286 65.9342 174.414 71.2895 182.67 75.0085C182.819 75.0829 183.005 75.1573 183.228 75.2317C183.451 75.306 183.6 75.3804 183.674 75.4548C183.823 75.5291 184.009 75.6035 184.232 75.6779C186.315 76.5705 187.691 77.2027 188.36 77.5746C189.104 77.8721 190.108 78.3928 191.373 79.1366C192.637 79.8803 193.492 80.6613 193.939 81.4795C194.385 82.2233 194.608 83.0787 194.608 84.0456C194.608 85.682 193.901 86.9836 192.488 87.9505C191.149 88.8431 189.253 89.2894 186.798 89.2894C180.997 89.2894 175.604 87.6158 170.621 84.2687V96.5414C174.935 98.8471 180.587 100 187.579 100C193.901 100 198.959 98.5124 202.753 95.5372C206.546 92.562 208.443 88.434 208.443 83.1531C208.443 79.3597 207.29 76.273 204.984 73.8928C202.678 71.5127 199.554 69.3557 195.612 67.4218C195.017 67.1243 194.199 66.7523 193.158 66.3061C192.116 65.8598 191.298 65.4879 190.703 65.1904C190.108 64.8929 189.401 64.5582 188.583 64.1863C187.765 63.74 187.133 63.3309 186.687 62.959C186.24 62.5871 185.757 62.178 185.236 61.7318C184.79 61.2111 184.455 60.6904 184.232 60.1698C184.083 59.6491 184.009 59.0913 184.009 58.4963C184.009 56.9343 184.641 55.6698 185.906 54.7029C187.244 53.6615 189.067 53.1409 191.373 53.1409C196.951 53.1409 201.6 54.2566 205.319 56.488ZM129.643 99.4422H116.254V21.9016H129.643V99.4422ZM149.483 99.4422H165.215L145.066 71.3399C144.443 70.4709 144.462 69.2964 145.114 68.4486L164.768 42.8766H149.149L133.096 64.2102C130.577 67.5581 130.492 72.1448 132.885 75.5841L149.483 99.4422ZM13.3883 99.4422H0V21.9016H13.3883V99.4422Z"
          fill="#47505E"
        ></path>
      </svg>
    </>
  );
};

export default FullLogo;
